"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useAccessory = require("../../../../hooks/upsell/useAccessory");
var _services = require("../../../../services");
var _upsellActions = require("../../../../store/upsell/upsellActions");
var _upsellUtils = require("../../../../utils/upsellUtils");
var _SliderWithIcon = _interopRequireDefault(require("./SliderWithIcon"));
var _useAppDispatch = require("../../../../hooks/useAppDispatch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const RangeSliders = _ref => {
  var _currentVariant$price;
  let {
    onChangePaymentValues
  } = _ref;
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    currentVariant,
    slidersValues
  } = (0, _useAccessory.useAccessory)();
  const {
    totalPrice: {
      value: totalPriceValue
    },
    maxUpfront: {
      value: maxUpfrontValue
    },
    minUpfront: {
      value: minUpfrontValue
    },
    upfrontIncrementStep,
    maxTerm: {
      value: maxTermValue
    },
    minTerm: {
      value: minTermValue
    },
    termIncrementStep
  } = (_currentVariant$price = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.priceOffering) !== null && _currentVariant$price !== void 0 ? _currentVariant$price : {};
  const [upFrontValue, setUpFrontValue] = (0, _react.useState)(minUpfrontValue);
  const [recurringValue, setRecurringValue] = (0, _react.useState)(maxTermValue);
  const evaluatedPriceStep = (0, _react.useMemo)(() => (0, _upsellUtils.evaluateStepValue)({
    min: minUpfrontValue,
    max: maxUpfrontValue,
    stepValue: upfrontIncrementStep.value
  }), [minUpfrontValue, maxUpfrontValue, upfrontIncrementStep]);
  const evaluatedTermStep = (0, _react.useMemo)(() => (0, _upsellUtils.evaluateStepValue)({
    min: minTermValue,
    max: maxTermValue,
    stepValue: termIncrementStep.value
  }), [minTermValue, maxTermValue, termIncrementStep]);
  (0, _react.useEffect)(() => {
    const currentVariantData = slidersValues === null || slidersValues === void 0 ? void 0 : slidersValues[currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.id];
    setUpFrontValue((currentVariantData === null || currentVariantData === void 0 ? void 0 : currentVariantData.upFrontValue) || minUpfrontValue);
    setRecurringValue((currentVariantData === null || currentVariantData === void 0 ? void 0 : currentVariantData.recurringValue) || maxTermValue);
  }, [currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.priceOffering]);
  (0, _react.useEffect)(() => {
    onChangePaymentValues({
      totalPriceValue,
      upFrontValue,
      recurringValue
    });
  }, [upFrontValue, recurringValue]);
  const handleOnValueDecrease = (value, incrementStep, minValue, callbackFn, valueKey) => {
    const updatedValue = value - incrementStep < minValue ? value : value - incrementStep;
    callbackFn(updatedValue);
    dispatch((0, _upsellActions.setSlidersValues)({
      id: currentVariant.id,
      [valueKey]: updatedValue
    }));
  };
  const handleOnValueIncrease = (value, incrementStep, maxValue, callbackFn, valueKey) => {
    const updatedValue = value + incrementStep <= maxValue ? value + incrementStep : maxValue;
    callbackFn(updatedValue);
    dispatch((0, _upsellActions.setSlidersValues)({
      id: currentVariant.id,
      [valueKey]: updatedValue
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_SliderWithIcon.default, {
    title: _services.Services.locale.localeString('AccessoryModal.FirstSliderLabel'),
    minLabel: `${_services.Services.locale.localeString('AccessoryModal.Min')} ${minTermValue}`,
    maxLabel: `${_services.Services.locale.localeString('AccessoryModal.Max')} ${maxTermValue}`,
    minValue: minTermValue,
    maxValue: maxTermValue,
    increment: evaluatedTermStep,
    value: recurringValue,
    onChangeHandle: selectedIndex => {
      setRecurringValue(selectedIndex);
      dispatch((0, _upsellActions.setSlidersValues)({
        id: currentVariant.id,
        recurringValue: selectedIndex
      }));
    },
    sliderLabel: `${recurringValue} ${_services.Services.locale.localeString('AccessoryModal.Months')}`,
    onDecrease: () => {
      handleOnValueDecrease(recurringValue, evaluatedTermStep, minTermValue, setRecurringValue, 'recurringValue');
    },
    onIncrease: () => {
      handleOnValueIncrease(recurringValue, evaluatedTermStep, maxTermValue, setRecurringValue, 'recurringValue');
    }
  }), /*#__PURE__*/_react.default.createElement(_SliderWithIcon.default, {
    title: _services.Services.locale.localeString('AccessoryModal.SecondSliderLabel'),
    minLabel: `${_services.Services.locale.localeString('AccessoryModal.Min')} ${_services.Services.locale.formatPrice(minUpfrontValue, {
      fraction: false
    })}`,
    maxLabel: `${_services.Services.locale.localeString('AccessoryModal.Max')} ${_services.Services.locale.formatPrice(maxUpfrontValue, {
      fraction: false
    })}`,
    value: upFrontValue,
    maxValue: maxUpfrontValue,
    minValue: minUpfrontValue,
    increment: evaluatedPriceStep,
    onChangeHandle: selectedIndex => {
      setUpFrontValue(selectedIndex);
      dispatch((0, _upsellActions.setSlidersValues)({
        id: currentVariant.id,
        upFrontValue: selectedIndex
      }));
    },
    sliderLabel: `${_services.Services.locale.formatPrice(upFrontValue, {
      fraction: false
    })}`,
    onDecrease: () => {
      handleOnValueDecrease(upFrontValue, evaluatedPriceStep, minUpfrontValue, setUpFrontValue, 'upFrontValue');
    },
    onIncrease: () => {
      handleOnValueIncrease(upFrontValue, evaluatedPriceStep, maxUpfrontValue, setUpFrontValue, 'upFrontValue');
    }
  }));
};
var _default = RangeSliders;
exports.default = _default;